import React, { useState } from 'react';
import './Publication.css'; // Ensure this CSS file is updated accordingly

const Publication = ({
	title,
	authors,
	conference,
	year,
	imageUrl,
	arxivLink,
	projectLink,
	bibtex,
	slides,
	poster,
	video,
	awards,
	acceptanceRate,
	otherVersions
}) => {
	const [showBibtex, setShowBibtex] = useState(false);
	const [showStats, setShowStats] = useState(false);
	const [showLightbox, setShowLightbox] = useState(false);

	return (
		<div className="publication-card">
			<div className="publication-sidebar">
				<div className="publication-image-container" onClick={() => setShowLightbox(true)}>
					<img src={imageUrl} alt={title} className="publication-image" />
					<span className="image-zoom-hint">🔍</span>
				</div>
			</div>

			{showLightbox && (
				<div className="lightbox-overlay" onClick={() => setShowLightbox(false)}>
					<div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
						<img src={imageUrl} alt={title} className="lightbox-image" />
						<button className="lightbox-close" onClick={() => setShowLightbox(false)}>✕</button>
					</div>
				</div>
			)}

			<div className="publication-main">
				<h3 className="publication-title">{title}</h3>
				<div className="publication-authors">{authors.join(', ')}</div>

				<div className="publication-meta">
					<span className="publication-conference">{conference}</span>
					<span className="publication-year">{year}</span>
					{acceptanceRate && (
						<span className="publication-stat">Acceptance: {acceptanceRate}</span>
					)}
				</div>

				{awards && (
					<div className="publication-awards">
						{(Array.isArray(awards) ? awards : [awards]).map((award, idx) => {
							const awardClass = award.toLowerCase().includes('oral') ? 'award-oral' :
								award.toLowerCase().includes('highlight') ? 'award-highlight' : '';
							return (
								<span key={idx} className={`award-badge ${awardClass}`}>
									🏆 {award}
								</span>
							);
						})}
					</div>
				)}

				<div className="publication-links">
					<a href={arxivLink} target="_blank" rel="noopener noreferrer" className="pub-link">Paper</a>
					{projectLink && <a href={projectLink} target="_blank" rel="noopener noreferrer" className="pub-link">Project</a>}
					<button onClick={() => setShowBibtex(!showBibtex)} className="pub-link">BibTeX</button>
					{slides && <a href={slides} target="_blank" rel="noopener noreferrer" className="pub-link">Slides</a>}
					{poster && <a href={poster} target="_blank" rel="noopener noreferrer" className="pub-link">Poster</a>}
					{video && <a href={video} target="_blank" rel="noopener noreferrer" className="pub-link">Video</a>}
				</div>

				{showBibtex && (
					<div className="bibtex-box">
						<pre>{bibtex}</pre>
						<button onClick={() => navigator.clipboard.writeText(bibtex)} className="copy-btn">Copy</button>
					</div>
				)}

				{otherVersions && (
					<div className="publication-versions">
						<span className="version-label">Other Versions:</span>
						{otherVersions.map((v, i) => (
							<a key={i} href={v.projectLink} target="_blank" rel="noopener noreferrer" className="version-link">
								{v.conference}
							</a>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default Publication;
